import Axios from "axios";
import { url } from "../../global";

const saveKanbanTMMIN = (data) => {
    return (dispatch, getState) => {
        dispatch({
            type: 'SAVE_KANBANTMMIN',
            payload: Axios.post(`${url}/kanban-tmmin`, {
                rack_id: data.rack_id,
                rack_name: data.rack_name,
                parts: data.parts
            }, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`
                }
            })
        })
    }
}

export { saveKanbanTMMIN }